import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Container,
  MainContent,
  StickyHeader
} from "../styled-components/Layout";
import { CloseButton } from "../styled-components/";
import { TitleBar, Title } from "../styled-components/Popup";
import localize from "../util/localizeUtils";
import DarkLightModeButton from "./DarkLightModeButton";

const Overlay = styled.div`
  display: block;
  position: absolute;
  z-index: 1000;
  height: 100%;
  width: 100%;

  top: 0;
  left: 0;

  padding: ${props => props.padding || "0"};

  will-change: transition;

  -webkit-transition: all 500ms cubic-bezier(0.165, 0.84, 0.44, 1),
    z-index 500ms;
  -moz-transition: all 500ms cubic-bezier(0.165, 0.84, 0.44, 1), z-index 500ms;
  -ms-transition: all 500ms cubic-bezier(0.165, 0.84, 0.44, 1), z-index 500ms;
  transition: all 500ms cubic-bezier(0.165, 0.84, 0.44, 1), z-index 500ms;

  &.hidden {
    z-index: -1;
    transform: translate(-100%);
    -webkit-transform: translate(-100%);
    -ms-transform: translate(-100%);
    -moz-transform: translate(-100%);
  }
`;

const OverlayContent = styled(MainContent)`
  height: 100%;
`;

const Close = styled(CloseButton)`
  font-size: 12px;
  padding: 0 1rem;
  height: 100%;
`;

const DarkModeIcon = styled.div`
  color: ${props => props.theme.modal.headerText};
  font-size: 24px;
  margin-right: 0.25rem;
  display: flex;
`;

class SlidingOverlay extends Component {
  constructor() {
    super();
    this.overlay = null;
  }

  componentDidMount() {
    if (this.overlay) {
      this.overlay.addEventListener("transitionend", this.toggleHidden);
    }
  }

  componentWillUpdate(nextProps) {
    if (!this.props.visible && nextProps.visible) {
      if (this.overlay) {
        this.overlay.style.display = "block";
      }
    }
  }

  componentWillUnmount() {
    if (this.overlay) {
      this.overlay.removeEventListener("transitionend", this.toggleHidden);
    }
  }

  toggleHidden = () => {
    if (this.overlay && !this.props.visible) {
      this.overlay.style.display = "none";
    }
  };

  onClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  renderTitleBar = () => (
    <StickyHeader>
      <TitleBar>
        <Title>{this.props.title}</Title>
        <DarkModeIcon>
          <DarkLightModeButton />
        </DarkModeIcon>
        {this.props.onClose ? (
          <Close onClick={this.onClose}>{this.props.closeText}</Close>
        ) : (
          ""
        )}
      </TitleBar>
    </StickyHeader>
  );

  render() {
    const { children, visible, title, padding } = this.props;
    return (
      <Overlay
        ref={r => (this.overlay = r)}
        padding={padding}
        className={!visible ? "hidden" : ""}
      >
        <Container>
          {title ? this.renderTitleBar() : ""}
          <OverlayContent>{children}</OverlayContent>
        </Container>
      </Overlay>
    );
  }
}

SlidingOverlay.defaultProps = {
  children: [],
  visible: false,
  title: null,
  onClose: null,
  closeText: localize("closeButton") /* '\u00D7',*/,
  padding: "0"
};

SlidingOverlay.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  visible: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func,
  closeText: PropTypes.string,
  padding: PropTypes.string
};

export default SlidingOverlay;



// WEBPACK FOOTER //
// ./app/components/SlidingOverlay.js